import OperationButton, {
  followType,
} from "@/components/FollowButton/operationButton";
import HBIcon from "@/components/HBIcon";
import { useLogin } from "@/components/LoginModal";
import { PIN_OPEN_TYPE } from "@/constants/pinOpenType";
import useAppStore from "@/context/store";
import { followBoard, unfollowBoard } from "@/services";
import displayNum from "@/utils/displayNum";
import getNextDetailsSetp from "@/utils/getHistorySetp";
import { Button } from "antd";
import { useRouter } from "next/router";
import { useMemo } from "react";
import { Else, If, Then, When } from "react-if";
import PinBoardPinList from "../PinBoardPinList";
import styles from "../index.module.less";

export default function Board({ data, setPin, isModal }) {
  const { login } = useLogin();
  const router = useRouter();
  const { currentPin, user, pinOpenType } = useAppStore(
    ({ currentPin, user, pinOpenType }) => ({
      currentPin,
      user,
      pinOpenType,
    })
  );
  const onToggleFollowBoard = async () => {
    if (!user) {
      const result = await login({ title: "扫码登录，关注画板不再错过更新" });
      if (!result) {
        return;
      }
    }

    if (pin?.board?.following) {
      const result = await unfollowBoard(pin.board.board_id);
      if (!result.err) {
        setPin({
          ...pin,
          board: {
            ...pin.board,
            following: false,
            follow_count: pin.board.follow_count - 1,
          },
        });
      }
    } else {
      const result = await followBoard(pin.board.board_id);
      if (!result.err) {
        setPin({
          ...pin,
          board: {
            ...pin.board,
            following: true,
            follow_count: pin.board.follow_count + 1,
          },
        });
      }
    }
  };
  const onSelectPin = (pin, currentSrc, source) => {
    const param = source ? `?from=${source}` : "";
    const pinId = pin.pin_id;
    if (pinOpenType === PIN_OPEN_TYPE.BLANK) {
      window.open(`/pins/${pinId}${param}`);
      return;
    }
    if (isModal) {
      // currentSrc用于渐进式显示图片，先显示缓存图，再显示大图
      useAppStore.setState({ currentPin: { pinId, currentSrc } });
      let detailsSetp = getNextDetailsSetp();
      let historyData =
        typeof history?.state === "object" ? history?.state : {};
      window.history.pushState(
        { ...historyData, detailsSetp },
        null,
        `/pins/${pinId}${param}`
      );
    } else {
      // 用于渐进式显示图片，先显示缓存图，再显示大图，但是这个router.push的方式所以只能把缓存图片地址通过window传递
      window._pinDetailCurrentSrc = currentSrc;
      router.push(`/pins/${pinId}${param}`);
    }
  };
  const pin = useMemo(() => {
    return data || currentPin;
  }, [data, currentPin]);

  return (
    <>
      <div className={styles.board}>
        <div className={styles.desc}>
          <div className={styles.left}>
            <When condition={pin?.board?.title}>
              <a
                className={styles.name}
                data-gd-click="button_click"
                data-button-name="打开采集所在画板"
                href={`/boards/${pin?.board?.board_id}`}
                target="_blank"
                rel="noreferrer"
              >
                <HBIcon className={styles.icon} type="dashboard" />
                <span className={styles.text} title={pin?.board?.title}>
                  {pin?.board?.title}
                </span>
              </a>
            </When>
            <div className={styles.num}>
              {displayNum(pin?.board?.pin_count) || 0}采集 ·{" "}
              {displayNum(pin?.board?.follow_count) || 0}关注
            </div>
          </div>
          <div className={styles.right}>
            <When condition={user?.user_id !== pin?.user_id}>
              <If condition={pin?.board?.following}>
                <Then>
                  {pin?.board?.user_following === followType.unIndependent ? (
                    <Button
                      type="text"
                      onClick={onToggleFollowBoard}
                      data-gd-click="button_click"
                      data-button-name="取消关注画板"
                    >
                      已关注
                    </Button>
                  ) : (
                    <OperationButton
                      type="text"
                      className={styles.operationButton}
                      onClick={onToggleFollowBoard}
                      data-gd-click="button_click"
                      data-button-name="取消关注画板"
                      boardInfo={pin?.board}
                    ></OperationButton>
                  )}
                </Then>
                <Else>
                  <Button
                    onClick={onToggleFollowBoard}
                    data-gd-click="button_click"
                    data-button-name="关注画板"
                  >
                    关注画板
                  </Button>
                </Else>
              </If>
            </When>
          </div>
        </div>
        {/* 不使用currentPin 作为兜底数据，因为该组件监听pin变化会导致多次请求 */}
        <PinBoardPinList pin={data} onSelect={onSelectPin} />
      </div>
    </>
  );
}
